// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4.286 21A1.286 1.286 0 013 19.714V5.571A2.571 2.571 0 015.571 3h14.143a1.286 1.286 0 110 2.571H5.893a.321.321 0 00-.322.322v13.821A1.286 1.286 0 014.286 21z\" fill=\"currentColor\"/></svg>";
// Exports
module.exports = code;